export const Academy = 'Academy/';
export const GetDigitalContent = Academy + 'DigitalContent';
export const GetDigitalContentSectionItem = Academy + 'GetDigitalContentSectionItem';
export const GetTrainingWebinar = Academy + 'TrainingWebinar';
export const GetTrainingWebinarSectionItem = Academy + 'GetTrainingWebinarSectionItem';
export const GetPublicEvent = Academy + 'PublicEvent';
export const GetPublicEventSectionItem = Academy + 'GetPublicEventSectionItem';